import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WebhookEndpoint } from '../models/Webhooks';
import { WebhooksApiAdapter } from '../adapters/WebhooksApiAdapter';

interface UseWebhookEndpointReturn {
  endpoint: WebhookEndpoint | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: UseQueryResult['refetch'];
}

export const useWebhookEndpoint = (id: number | null): UseWebhookEndpointReturn => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WebhooksApiAdapter(httpClient);

  const { data, isLoading, error, refetch } = useQuery<WebhookEndpoint, Error>({
    queryKey: ['webhook-endpoint', id],
    queryFn: async () => {
      const response: any = await adapter.getEndpointById(id!);
      return response.data ?? response;
    },
    enabled: id !== null,
    staleTime: 60 * 1000,
  });

  return {
    endpoint: data,
    isLoading,
    error,
    refetch,
  };
};
